import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/site-data";
import { Reveal, Eyebrow } from "./Reveal";

export default function Testimonials() {
  return (
    <section id="yorumlar" className="relative py-24 md:py-32">
      <div className="pointer-events-none absolute -right-32 top-1/4 h-[380px] w-[380px] rounded-full bg-[#1E7FFF]/10 blur-[140px]" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <Eyebrow>Müşteri Yorumları</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 max-w-2xl font-syne text-3xl font-bold tracking-tight md:text-5xl">
            Birlikte Çalıştığımız Markalar <span className="text-[#1E7FFF]">Ne Diyor?</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={0.08 * i} className="h-full">
              <figure
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col rounded-2xl border border-[#2E4390] bg-[#1A2E78]/70 p-7 backdrop-blur-md transition-all duration-300 hover:-translate-y-1.5 hover:border-[#1E7FFF]"
              >
                <div className="flex items-start justify-between gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#1E7FFF]/15 text-[#5CA3FF]">
                    <Quote size={20} />
                  </span>
                  {t.source && (
                    <span className="rounded-full border border-[#2E4390] bg-[#122263]/80 px-3 py-1 font-code text-[10px] tracking-[0.15em] uppercase text-[#8B9AC4]">
                      {t.source}
                    </span>
                  )}
                </div>
                <div className="mt-4 flex gap-1" aria-label="5 yıldız">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={15} className="fill-[#F5B301] text-[#F5B301]" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-[#B9C4E8]">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-6 border-t border-[#2E4390]/60 pt-4">
                  <p className="font-syne text-sm font-bold text-[#F8FAFC]">{t.name}</p>
                  <p className="font-code mt-1 text-[10px] tracking-[0.2em] uppercase text-[#8B9AC4]">{t.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
